
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBackspaceGoogle as ObiBackspaceGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-backspace-google.js';
 
 
 

 
 export const ObiBackspaceGoogle = createComponent({
   react: React,
   tagName: 'obi-backspace-google',
   elementClass: ObiBackspaceGoogleElement,
   events: {
     
   }
  });
 
 